import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'home',
        component: HomeView
    },
    {
        path: '/about',
        name: 'about',
        component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
    },
    {
        path: '/services',
        name: 'services',
        component: () => import(/* webpackChunkName: "about" */ '../views/ServicesView.vue')
    },
    {
        path: '/showcase',
        name: 'showcase',
        component: () => import(/* webpackChunkName: "about" */ '../views/ShowcaseView.vue')
    },
    {
        path: '/showcaseDetails',
        name: 'showcaseDetails',
        component: () => import(/* webpackChunkName: "about" */ '../views/ShowcaseDetailsView.vue')
    },

]

const router = new VueRouter({
    routes,
    scrollBehavior() {
        // 总是滚动到页面顶部
        return {x: 0, y: 0};
    }
})

export default router
